import _o2sService from './_o2sServices';
import { IFilter } from '../models/filters/filter';

import { IClientOrderFilter } from '../models/filters/clientOrderFilter';
import { API_CENTRE } from './config';

export default class ClientOrderServices extends _o2sService {
   protected static override mainUrl:string = API_CENTRE + '/api/v1/ClientOrder';
   protected static override getUrlFilter<F extends IClientOrderFilter>(filter?: F): string {
       let url = super.getUrlFilter(filter as IFilter);
       if (filter != null) 
       {
           if (filter.orderNumber != null)
               url += '&OrderNumber=' + filter.orderNumber;
           if (filter.centerId != null)
            url += '&CenterId=' + filter.centerId;
       }
       return url;
   }

}
